import React, { useState, setState, useEffect, useContext } from "react";
import axios from "axios";
import { makeStyles } from "@material-ui/core/styles";

import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";

import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import FormHelperText from "@material-ui/core/FormHelperText";
import FormControl from "@material-ui/core/FormControl";
import Select from "@material-ui/core/Select";

import { BootstrapTable, TableHeaderColumn } from "react-bootstrap-table";

export default function AdjustmentTypes(props) {
  //const user = useContext(UserContext);
  const useStyles = makeStyles((theme) => ({
    root: {
      width: "100%",
    },
    formControl: {
      minWidth: 120,
    },
    selectEmpty: {
      marginTop: theme.spacing(2),
    },
    title: {
      marginLeft: theme.spacing(2),
      flex: 1,
    },
    button: {},

    center: {
      margin: "0 auto",
      border: "1px grey black",
      textAlign: "center",
      width: "75%",
      "& .MuiTextField-root": {
        margin: theme.spacing(1),
        width: 200,
      },
      "& .MuiFormGroup-row": {
        justifyContent: "center",
      },
      "& .MuiFormControl-root": {
        justifyContent: "center",
      },
    },
  }));
  const classes = useStyles();

  const [adjustmentTypes, setAdjustmentTypes] = React.useState([]);
  const [selectedAdjustmentType, setSelectedAdjustmentType] = React.useState(1);

  useEffect(() => {
    GetAdjustmentTypes();
  }, []);

  const GetAdjustmentTypes = () => {
    let url = process.env.REACT_APP_API2_URL + "/Player/AdjustmentType_GetList";

    axios({
      method: "get",
      url: url,
      /*  REPLACE WITH SELECT DATA */
    })
      .then((response) => response.data)
      .then((data) => {
        setAdjustmentTypes(data);
      });
  };

  const handleMethodChange = (event) => {
    props.setIdAdjTypeMem(event.target.value);
    setSelectedAdjustmentType(event.target.value);
  };

  return (
    <React.Fragment>
      <FormControl
        className={`${classes.formControl} w-full`}
        size="small"
        variant="outlined"
      >
        <InputLabel shrink id="demo-simple-select-placeholder-label-label">
          Adjustment Type
        </InputLabel>
        {adjustmentTypes[0] && (
          <Select
            labelId="demo-simple-select-placeholder-label-label"
            id="demo-simple-select-placeholder-label"
            value={selectedAdjustmentType}
            onChange={handleMethodChange}
            displayEmpty
          >
            {adjustmentTypes.map((AdjustmentType) => (
              <MenuItem
                /*key={AdjustmentType.NumberOfAdjustmentType}*/ value={
                  AdjustmentType.idAdjustmentType
                }
              >
                {AdjustmentType.adjustmentTypeName}
              </MenuItem>
            ))}
          </Select>
        )}
      </FormControl>
    </React.Fragment>
  );
}
